<template>
  <div
    class="modal-bg"
    v-if="isOpen"
    ref="modalBg"
    @mousedown="modalBgClick"
  >
    <button
      v-if="withoutTemplate"
      class="closeModalMobileBtn"
      @click="close"
    >&times;</button>
    <slot v-if="withoutTemplate"></slot>
    <div class="modal" v-else>
      <div class="modal-header">
        <div class="modal-header-title">
          {{title}}
        </div>
        <button class="modal-close" @click="close"></button>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      isOpen: Boolean,
      close: Function,
      title: String,
      withoutTemplate: Boolean
    },
    methods: {
      modalBgClick(e) {
        if (e.target === this.$refs.modalBg) {
          this.close()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .closeModalMobileBtn {
    display: none;
  }
  .modal-bg {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal {
    padding: 25px 30px;
    width: 100%;
    max-width: 460px;
    background: #FFFFFF;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04), 0 10px 20px rgba(0, 0, 0, 0.04);
    border-radius: 10px;

    &-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      &-title {
        font-weight: 600;
        font-size: 32px;
        line-height: 1.25;
        color: #383838;
      }
    }

    &-close {
      width: 40px;
      height: 40px;
      background-image: url('../../assets/images/icons/close.svg');
      background-position: center center;
      background-size: contain;
      border: none;
      background-color: transparent;
    }

  }

  @media screen and (max-width: 576px){
    .closeModalMobileBtn {
      // display: block;
      position: absolute;
      z-index: 9;
      right: 20px;
      top: 20px;
      width: 40px;
      height: 40px;
      font-size: 40px;
      background-color: transparent;
      border: none;
    }
  }
</style>
